module.exports = __webpack_public_path__ + "static/media/leadnow.eb905e0a.jpg";